<form [formGroup]="form">
  <div class="modal-header">
    <div class="d-flex align-items-center gap-2">
      <h5 class="modal-title">
        {{ config.title }}
      </h5>
      <app-page-help [articleId]="config.articleId" *ngIf="config.articleId"></app-page-help>
    </div>
    <button (click)="close()" type="button" class="close">
      <i class="far fa-times"></i>
    </button>
  </div>
  <div class="modal-body">
    <mat-form-field2>
      <app-select
        [bindLabel]="config.bindLabel"
        [bindValue]="config.bindValue"
        [required]="true"
        [items]="config.list"
        [formControl]="form.get('selected')"
        [multiple]="config.multiple"
        [placeholder]="config.placeholder"
      >
        <ng-template selectItem let-item="item" let-label="label">
          <div [matTooltip]="item[config.bindTooltip]" matTooltipPosition="right">{{ label }}</div>
        </ng-template>
      </app-select>
      <mat-error *ngIf="form.get('selected').touched && form.get('selected').hasError('required')" i18n
        >Value is required</mat-error
      >
    </mat-form-field2>
    <p [innerHtml]="config.help"></p>
  </div>
  <div class="modal-footer">
    <button (click)="close()" type="button" class="btn btn-light">
      <i class="far fa-times"></i><ng-container i18n>Cancel</ng-container>
    </button>
    <button (click)="save(form)" type="button" class="btn btn-secondary-info create-btn">
      <i [ngClass]="config.buttonIcon" *ngIf="!config.iconRight"></i>
      {{ config.buttonText }}
      <i [ngClass]="config.buttonIcon" *ngIf="config.iconRight"></i>
    </button>
  </div>
</form>
